export default __webpack_public_path__ + "static/media/section1-background.cc0ce33e.jpg";